type MenuData = {
	name: string;
	route: string;
	icon: string;
	sub_menu: SubMenuData[];
	collapse: boolean;
	permissions: PermissionsData;
}
type SubMenuData = {
	name: string;
	route: string;
	icon: string;
	permissions: PermissionsData;
}
type PermissionsData = {
	alterar: boolean;
	baixa: boolean;
	confirmar: boolean;
	excluir: boolean;
	incluir: boolean;
}

export default async function menuRoute(route: string, menu: MenuData[]): Promise<PermissionsData> {
	for (let i = 0; i < menu.length; i++) {
		if (menu[i].route && menu[i].route === route) {
			return menu[i].permissions;
		}

		if (menu[i].sub_menu) {
			for (let j = 0; j < menu[i].sub_menu.length; j++) {
				if (menu[i].sub_menu[j].route === route) {
					return menu[i].sub_menu[j].permissions;
				}
			}
		}
	}

	return {} as PermissionsData;
}